import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Input,
  Select,
  Tag,
  Button,
  Dropdown,
  Menu,
  Modal,
  Form,
  Card,
  message,
} from "antd";
// import { Link } from "react-router-dom";
// import Docsample from '../../Images/docsample.png';
import AppConfigs from "../../Config/AppConfig";
import { getDetails, list, update } from "../../api/Apis";
import { withAppContext } from "../../store/contextStore";
import { formatPhoneNumber, showTotal } from "../commonFunctions";
import ResizableAntdTable from "resizable-antd-table";
import LocationAutocomplete from "../../Components/Autocomplete";
import ErrorPage from "../ErrorPage";
import DownloadCsv from "../../Components/DownloadCsv";

const Search = Input.Search;
const { Option } = Select;

class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customersList: [],
      totalCustomersList: [],
      dataLoadingStatus: true,
      userModalVisible: false,
      userData: {},
      buttonText: "",
      formSubmitStatus: false,
      selectedCustomerAddress: "",
      selectedCustomerId: "",
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
  }

  componentDidMount() {
    this.getUsers();
  }
  getUsers = () => {
    let query = {
      registrationType: "customer",
    };
    list(AppConfigs["entityNames"]["registrations"], query).then((result) => {
      if (result.success) {
        let customersList = result.data.sort((a, b) =>
          parseInt(a["createdAt"]) < parseInt(b["createdAt"]) ? 1 : -1
        );
        customersList = customersList.filter(
          (item) => item.userProfile !== "SCU"
        );
        this.setState({
          customersList: customersList,
          totalCustomersList: customersList,
          dataLoadingStatus: false,
        });
      } else {
        this.setState({
          dataLoadingStatus: false,
        });
        console.log(result.errors);
      }
    });
  };

  searchData = (event, searchType) => {
    let searcingValue = searchType === "text" ? event.target.value : event;
    let totalCustomersList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      if (searchType === "text") {
        totalCustomersList = this.state.totalCustomersList.filter(
          (customer) =>
            (customer?.companyName !== null &&
              customer?.companyName.toLowerCase().indexOf(searcingValue) >
                -1) ||
            (customer?.address !== null &&
              customer?.address?.toLowerCase().indexOf(searcingValue) > -1) ||
            (customer?.phone !== null &&
              customer?.phone?.indexOf(searcingValue) > -1) ||
            (customer?.email !== null &&
              customer?.email?.toLowerCase().indexOf(searcingValue) > -1)
        );
      } else {
        totalCustomersList = this.state.totalCustomersList.filter(
          (customer) => customer.approvalStatus.toLowerCase() === searcingValue
        );
      }
    } else {
      totalCustomersList = this.state.totalCustomersList;
    }
    this.setState({
      customersList: totalCustomersList,
    });
  };

  addCustomer = () => {
    this.props.history.push("/app/addcustomer");
  };

  handleTableChange = (pagination, filters, sorter) => {
    let customersList = [];
    if (sorter["order"] === "descend") {
      if (sorter["columnKey"] === "approvalStatus") {
        customersList = this.state.customersList.sort((a, b) =>
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][a["approvalStatus"]] <
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][b["approvalStatus"]]
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "phone") {
        customersList = this.state.customersList.sort((a, b) =>
          parseInt(a["phone"]) < parseInt(b["phone"]) ? 1 : -1
        );
      } else if (sorter["columnKey"] === "companyName") {
        customersList = this.state.customersList.sort((a, b) =>
          a["companyName"].toLowerCase() < b["companyName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "email") {
        customersList = this.state.customersList.sort((a, b) =>
          a["email"].toLowerCase() < b["email"].toLowerCase() ? 1 : -1
        );
      } else if (sorter["columnKey"] === "address") {
        customersList = this.state.customersList.sort((a, b) =>
          a["address"].toLowerCase() < b["address"].toLowerCase() ? 1 : -1
        );
      }
    } else if (sorter["order"] === "ascend") {
      if (sorter["columnKey"] === "approvalStatus") {
        customersList = this.state.customersList.sort((a, b) =>
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][a["approvalStatus"]] >
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][b["approvalStatus"]]
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "phone") {
        customersList = this.state.customersList.sort((a, b) =>
          parseInt(a["phone"]) > parseInt(b["phone"]) ? 1 : -1
        );
      } else if (sorter["columnKey"] === "companyName") {
        customersList = this.state.customersList.sort((a, b) =>
          a["companyName"].toLowerCase() > b["companyName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "email") {
        customersList = this.state.customersList.sort((a, b) =>
          a["email"].toLowerCase() > b["email"].toLowerCase() ? 1 : -1
        );
      } else if (sorter["columnKey"] === "address") {
        customersList = this.state.customersList.sort((a, b) =>
          a["address"].toLowerCase() > b["address"].toLowerCase() ? 1 : -1
        );
      }
    } else {
      customersList = this.state.customersList;
    }
    this.setState({
      customersList: customersList,
    });
  };

  handleEdit = (e) => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          formSubmitStatus: true,
        });
        let data = {};
        if (values.userProfile === "Customer Admin") {
          values.userProfile = "CU";
        } else if (values.userProfile === "Sub User") {
          values.userProfile = "SCU";
        }
        data["entityData"] = values;

        update(
          AppConfigs["entityNames"]["registrations"],
          this.state.userData.id,
          data
        ).then((result) => {
          if (result.success) {
            update(
              AppConfigs["entityNames"]["users"],
              this.state.selectedCustomerId,
              data
            ).then((result) => {
              if (result.success) {
                message.success(`User details updated successfully.`);
                this.getUsers();
                this.props.form.resetFields();
                this.setState({
                  formSubmitStatus: false,
                  userModalVisible: false,
                  buttonText: "",
                  userData: { ...this.state.userData },
                });
              } else {
                message.error(result.errors);
              }
            });
          } else {
            message.error(result.errors);
          }
        });
      }
    });
  };

  getCustomerDetails = (id, record) => {
    this.setState({
      dataLoadingStatus: true,
    });
    getDetails(AppConfigs["getRegisterDetails"], id).then(async (result) => {
      if (result.success) {
        let loginDetails = result.data["loginDetails"];
        record["firstName"] = loginDetails["firstName"];
        record["lastName"] = loginDetails["lastName"];
        record["userProfile"] = loginDetails["userProfile"];
        console.log(record);
        this.setState({
          userModalVisible: true,
          userData: record,
          buttonText: "Update",
          dataLoadingStatus: false,
          selectedCustomerAddress: record.address,
          selectedCustomerId: loginDetails["id"],
        });
      } else {
        console.log(result.errors);
      }
    });
  };

  getAddress = (address, latLng, fieldId) => {
    this.props.form.setFieldsValue({
      [fieldId]: address,
    });
    let latLangs = this.state.latLangs;
    latLangs[fieldId] = latLng;
    this.setState({
      latLangs,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const columns = [
      {
        title: <div style={{ color: "grey" }}>Status</div>,
        key: "approvalStatus",
        dataIndex: "approvalStatus",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/customers/customerdetails/" + record.id),
          style: { cursor: "pointer" },
        }),
        render: (tag) => (
          <span className="status_tag">
            {/* <Tag color={tag === "A" ? "green" : tag === "P" ? 'yellow' : tag === "F" ? "blue" : "red"} key={tag} style={{color: 'black', height: '27px', fontSize: '12px', fontWeight: 'bold'}}>
                {tag === "A" ? "Approved" : tag === "P" ? "Pending" : tag === "F" ? "Freezed" : "Rejected"}
            </Tag> */}
            <Tag
              color={
                tag === "A"
                  ? "green"
                  : tag === "P"
                  ? "yellow"
                  : tag === "F"
                  ? "blue"
                  : "red"
              }
              key={tag}
              style={{
                color: "black",
                height: "27px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][tag]}
            </Tag>
            {/* <div>{approvalStatus}</div> */}
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Company</div>,
        dataIndex: "companyName",
        key: "companyName",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/customers/customerdetails/" + record.id),
          style: { cursor: "pointer" },
        }),
        render: (company) => (
          <span>
            <div style={{ color: "black" }}>{company}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Phone</div>,
        dataIndex: "phone",
        key: "phone",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/customers/customerdetails/" + record.id),
          style: { cursor: "pointer" },
        }),
        render: (phone) => (
          <span>
            <div style={{ color: "black" }}>{formatPhoneNumber(phone)}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/customers/customerdetails/" + record.id),
          style: { cursor: "pointer" },
        }),
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Address</div>,
        dataIndex: "address",
        key: "address",
        // sorter: true,
        onCell: (record) => ({
          onClick: () =>
            (window.location = "/app/customers/customerdetails/" + record.id),
          style: { cursor: "pointer" },
        }),
        render: (address) => (
          <span>
            <div style={{ color: "black" }}>{address}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "grey" }}>Action</div>,
        dataIndex: "id",
        key: "id",
        render: (id, record) => (
          <Dropdown overlay={menu(id, record)} placement="bottomRight">
            <Button>...</Button>
          </Dropdown>
        ),
      },
    ];
    const menu = (id, record) => (
      <Menu>
        <Menu.Item
          className="blue"
          onClick={() => this.getCustomerDetails(id, record)}
        >
          <span style={{ color: "rgba(0, 0, 0, 0.65)", cursor: "pointer" }}>
            Edit
          </span>
        </Menu.Item>
      </Menu>
    );
    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }
    return (
      <div className="content-outer">
        <div className="content">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <h1 className="headings"> Customers </h1>
            </Col>
            <Row style={{ marginTop: "10px" }}>
              <Col xs={24} sm={24} md={4} lg={4} style={{ marginTop: "1%" }}>
                <Search
                  className="products-search"
                  size="large"
                  placeholder="Search"
                  onChange={(event) => this.searchData(event, "text")}
                />
              </Col>
              <Col xs={24} sm={24} md={2} lg={2} style={{ marginTop: "1%" }}>
                <div className="vl" />
              </Col>
              <Col xs={24} sm={24} md={3} lg={2} style={{ marginTop: "1%" }}>
                <div className="loads-select">
                  <Select
                    onChange={(event) => this.searchData(event, "status")}
                    placeholder={"State"}
                    defaultValue="All Status"
                    style={{ width: 140 }}
                  >
                    <Option key="All" value="">
                      All Status
                    </Option>
                    <Option key="A" value="A">
                      Approved
                    </Option>
                    <Option key="P" value="P">
                      Pending
                    </Option>
                    <Option key="D" value="D">
                      Declined
                    </Option>
                  </Select>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12}>
                {/* <Button type="primary" htmlType="submit" loading={this.state.loading} className="customer-add-button" onClick={() => this.addCustomer()} icon='plus'>
                  Customer
                </Button> */}
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: "2%" }}>
                <ResizableAntdTable
                  style={{ overflowX: "auto" }}
                  bordered={true}
                  columns={columns}
                  dataSource={this.state.customersList}
                  loading={this.state.dataLoadingStatus}
                  rowKey={(record) => record.id}
                  onChange={this.handleTableChange}
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                    total: this.state.customersList.length,
                    showTotal: showTotal,
                  }}
                  // onRow={(r) => ({
                  //   onClick: () =>
                  //     (window.location =
                  //       "/app/customers/customerdetails/" + r.id),
                  //   style: { cursor: "pointer" },
                  // })}
                />
              </Col>
              <Modal
                visible={this.state.userModalVisible}
                footer={[
                  <Button
                    key="cancel"
                    className="cancel"
                    onClick={() => {
                      this.props.form.resetFields();
                      this.setState({
                        userModalVisible: false,
                        formSubmitStatus: false,
                      });
                    }}
                  >
                    Cancel
                  </Button>,
                  <Button
                    key="assign"
                    className="assigning"
                    loading={this.state.formSubmitStatus}
                    onClick={this.handleEdit}
                  >
                    {this.state.buttonText}
                  </Button>,
                ]}
              >
                <div className="site-card-border-less-wrapper">
                  <Form>
                    <Card
                      title={
                        <h4 className="Companyheadinglabel">{"Edit User"}</h4>
                      }
                      style={{ borderRadius: "10px" }}
                    >
                      <Row gutter={10}>
                        <Col lg={24} md={24} sm={24} sx={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{
                                  color: "#7B8190",
                                  fontSize: "14px",
                                }}
                              >
                                First Name
                              </span>
                            }
                          >
                            {getFieldDecorator("firstName", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your First Name!",
                                },
                              ],
                              initialValue: this.state.userData.firstName,
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={24} md={24} sm={24} sx={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{
                                  color: "#7B8190",
                                  fontSize: "14px",
                                }}
                              >
                                Last Name
                              </span>
                            }
                          >
                            {getFieldDecorator("lastName", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Last Name!",
                                },
                              ],
                              initialValue: this.state.userData.lastName,
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        {/* <Col lg={24} md={24} sm={24} sx={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{
                                  color: "#7B8190",
                                  fontSize: "14px",
                                }}
                              >
                                Phone
                              </span>
                            }
                          >
                            {getFieldDecorator("phone", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Phone Number!",
                                },
                                noWhitespaceRule,
                                notValidPhoneNumberRule,
                              ],
                              initialValue: this.state.userData.phone,
                            })(<Input />)}
                          </Form.Item>
                        </Col> */}
                        <Col lg={24} md={24} sm={24} sx={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{
                                  color: "#7B8190",
                                  fontSize: "14px",
                                }}
                              >
                                Email
                              </span>
                            }
                          >
                            {getFieldDecorator("email", {
                              rules: [
                                {
                                  required: true,
                                  type: "email",
                                  message: "Please input your Email!",
                                },
                              ],
                              initialValue: this.state.userData.email,
                            })(<Input disabled={false} />)}
                          </Form.Item>
                        </Col>
                        <Col lg={24} md={24} sm={24} sx={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{
                                  color: "#7B8190",
                                  fontSize: "14px",
                                }}
                              >
                                Address
                              </span>
                            }
                          >
                            {getFieldDecorator("address", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Address!",
                                },
                              ],
                              initialValue: this.state.userData.address,
                            })(
                              <LocationAutocomplete
                                getAddress={(address, latLng) =>
                                  this.getAddress(address, latLng, "address")
                                }
                                editMode={true}
                                address={this.state.selectedCustomerAddress}
                                setAddress={(address) => {
                                  this.setState({
                                    selectedCustomerAddress: address,
                                  });
                                }}
                              />
                            )}
                          </Form.Item>
                        </Col>
                        <Col lg={24} md={24} sm={24} sx={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span
                                style={{ color: "#7B8190", fontSize: "14px" }}
                              >
                                User Profile
                              </span>
                            }
                          >
                            {getFieldDecorator("userProfile", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your User Profile!",
                                },
                              ],
                              initialValue:
                                this.state.userData.userProfile === "CU"
                                  ? "Customer Admin"
                                  : this.state.userData.userProfile === "SCU"
                                  ? "Sub User"
                                  : "",
                            })(
                              <Select>
                                <Option value="CU">Customer Admin</Option>
                                <Option value="SCU">Sub User</Option>
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                  </Form>
                </div>
              </Modal>
            </Row>
              <Button>
                <DownloadCsv
                  data={this.state.customersList}
                  columns={columns}
                  filename="customers"
                  />
              </Button>
          </Row>
        </div>
      </div>
    );
  }
}
export default Form.create({ name: "customers" })(
  withAppContext(withRouter(Customers))
);
